import CaseReportMenu from './CaseReportMenu'

export default CaseReportMenu
